import React from 'react';
import { motion } from 'framer-motion';
import { Phone, Mail, MapPin } from 'lucide-react';
import { Button } from './ui/Button';
export function ContactSection() {
  return <section id="contact" className="relative py-24 overflow-hidden" data-id="element-29">
      {/* Warm Gradient Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-sunrise-orange via-sunrise-brown to-sunrise-brown-dark" data-id="element-30" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-31">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-32">
          {/* Left Side: Info */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="text-white" data-id="element-33">
            <h2 className="font-heading text-4xl md:text-5xl font-bold mb-6" data-id="element-34">
              Ready to Start Your Project?
            </h2>
            <p className="text-xl text-white/90 mb-10 font-light" data-id="element-35">
              Get a free estimate today. Whether it's a single door replacement
              or a full home trim package, we're here to help.
            </p>

            <div className="space-y-8" data-id="element-36">
              <a href="tel:6026326929" className="flex items-center group" data-id="element-37">
                <div className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center group-hover:bg-white/20 transition-colors" data-id="element-38">
                  <Phone className="w-6 h-6 text-sunrise-gold" data-id="element-39" />
                </div>
                <span className="ml-4 font-heading text-3xl md:text-4xl font-bold" data-id="element-40">
                  602-632-6929
                </span>
              </a>

              <div className="flex items-center" data-id="element-41">
                <div className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center" data-id="element-42">
                  <Mail className="w-6 h-6 text-sunrise-gold" data-id="element-43" />
                </div>
                <span className="ml-4 text-lg" data-id="element-44">info@sunrisedoorntrim.com</span>
              </div>

              <div className="flex items-center" data-id="element-45">
                <div className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center" data-id="element-46">
                  <MapPin className="w-6 h-6 text-sunrise-gold" data-id="element-47" />
                </div>
                <span className="ml-4 text-lg" data-id="element-48">
                  Serving Gilbert, Phoenix & Surrounding Areas
                </span>
              </div>
            </div>
          </motion.div>

          {/* Right Side: Form */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="bg-white rounded-2xl p-8 shadow-2xl" data-id="element-49">
            <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-50">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-51">
                <div data-id="element-52">
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-53">
                    Name
                  </label>
                  <input type="text" id="name" className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-sunrise-orange focus:border-transparent outline-none transition-all" placeholder="Your Name" data-id="element-54" />
                </div>
                <div data-id="element-55">
                  <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-56">
                    Phone
                  </label>
                  <input type="tel" id="phone" className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-sunrise-orange focus:border-transparent outline-none transition-all" placeholder="(602) 555-0123" data-id="element-57" />
                </div>
              </div>

              <div data-id="element-58">
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-59">
                  Email
                </label>
                <input type="email" id="email" className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-sunrise-orange focus:border-transparent outline-none transition-all" placeholder="you@example.com" data-id="element-60" />
              </div>

              <div data-id="element-61">
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-62">
                  Project Description
                </label>
                <textarea id="message" rows={4} className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-sunrise-orange focus:border-transparent outline-none transition-all resize-none" placeholder="Tell us about your project..." data-id="element-63"></textarea>
              </div>

              <Button fullWidth size="lg" className="shadow-lg" data-id="element-64">
                Send Message
              </Button>
            </form>
          </motion.div>
        </div>
      </div>
    </section>;
}